import { useFetch } from 'utils/fetch'

function usePhoneNumbers() {
  const inboundQuery = useFetch('inbound/get_inbound', { queryKey: ['inboundNumbers'], staleTime: Infinity, dataKey: 'inboundNumbers' })
  const twilioQuery = useFetch('byot/get', { queryKey: ['byotNumbers'], staleTime: Infinity })

  return {
    inboundNumbers: inboundQuery.data || [],
    twilioNumbers: twilioQuery.data || [],
    loading: inboundQuery.isLoading || twilioQuery.isLoading,
    error: inboundQuery.error || twilioQuery.error,
    refreshNumbers: () => {
      inboundQuery.refetch()
      twilioQuery.refetch()
    },
  }
}

export default usePhoneNumbers
